import React, { useEffect, useState } from "react";
import { Button, Input, Select, Table, Tooltip } from "antd";
import axios from "axios";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import Swal from "sweetalert2";
import { EditOutlined, RestOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import StockUpdateModal from "./StockUpdateModal";
import StockDamageModal from "./StockDamageModal";
import dayjs from "dayjs";

export default function CenterStock() {
  const { Search } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [stockList, setStockList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [centerIds, setCenterIds] = useState([]);
  const [stockLoading, setStockLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [stockUpdateModal, setUpdateProductModal] = useState(false);
  const [stockDamageModal, setStockDamageModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [search, setSearch] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );
  const [selectedDateRange, setSelectedDateRange] = useState([]);

  const handleSalesDateRage = (value) => {
    console.log(value);
    if (value?.length === 2) {
      const startDate = dayjs(value[0]).startOf("day");
      const endDate = dayjs(value[1]).endOf("day");
      const updatedDateRange = [startDate, endDate];
      setSelectedDateRange(updatedDateRange);
      console.log(updatedDateRange);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    setSearch(value);
  };
  const handleCenter = (value) => {
    setCurrentPage(1);
    setSelectedCenter(value);
  };
  const handlePageChange = (page) => {
    console.log(page);
    setCurrentPage(page);
  };

  const handleUpdateModal = (record) => {
    setUpdateProductModal(true);
    setSelectedProduct(record);
  };
  const handleUpdateModalClose = () => {
    setUpdateProductModal(false);
  };
  const handleDamageModal = (record) => {
    setStockDamageModal(true);
    setSelectedProduct(record);
  };
  const handleDamageModalClose = () => {
    setStockDamageModal(false);
  };

  const fetchStockList = () => {
    setStockLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/stock_list/${userProfile?.employee_id}/`, {
        headers: authHeader(),
        params: {
          product_name: search,
          searched_center_id: selectedCenter,
          dateRange: selectedDateRange,
          page: currentPage,
        },
      })
      .then((response) => {
        setStockLoading(false);
        setStockList(response?.data?.results);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setStockLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchStockList();
  }, [currentPage, search, selectedCenter, selectedDateRange]);

  useEffect(() => {
    setStockLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setStockLoading(false);
        setCenterList(response?.data);
        const employeeIds = response?.data?.map(
          (center) => center?.center?.employee_id
        );
        setCenterIds(employeeIds);
      })
      .catch((error) => {
        setStockLoading(true);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const stockColumn = [
    {
      title: "Create Date",
      render: (record) =>
        record?.created_at
          ? new Date(record?.created_at).toISOString().slice(0, 10)
          : "",
      width: "8%",
    },
    {
      title: "Product Name",
      render: (record) => record?.product?.product_name,
      width: "8%",
    },
    {
      title: "Batch",
      dataIndex: "batch_id",
      width: "6%",
    },
    {
      title: "Agri Type",
      render: (record) => record?.product?.agri_type,
      width: "5%",
    },
    {
      title: "Brand Name",
      render: (record) => record?.product?.brand?.brand_name,
      width: "8%",
    },
    {
      title: "Stock In",
      dataIndex: "stock_in",
      width: "4%",
    },
    {
      title: "Stock Out",
      dataIndex: "stock_out",
      width: "4%",
    },
    centerIds?.includes(userProfile?.employee_id) ? (
      <></>
    ) : (
      {
        title: "Purchase",
        render: (record) => record?.purchase_price?.toLocaleString(),
        width: "5%",
      }
    ),

    {
      title: "Remaining",
      dataIndex: "stock",
      width: "5%",
    },
    {
      title: "Expire",
      render: (record) =>
        record?.expire_date
          ? new Date(record?.expire_date).toISOString().slice(0, 10)
          : "",
      width: "5%",
    },
    centerIds?.includes(userProfile?.employee_id) ? (
      <></>
    ) : (
      {
        title: "Stock Value",
        render: (record) =>
          (record?.purchase_price * record?.stock).toLocaleString(),
        width: "5%",
      }
    ),
    {
      title: "Farmer",
      render: (record) => record?.selling_rate_farmer?.toLocaleString(),
      width: "4%",
    },
    {
      title: "Retailer",
      render: (record) => record?.selling_rate_retailer?.toLocaleString(),
      width: "4%",
    },
    {
      title: "Contract Farmer",
      render: (record) =>
        record?.selling_rate_contract_farmer?.toLocaleString(),
      width: "5%",
    },
    {
      title: "IB Rate",
      render: (record) =>
        record?.selling_rate_institutional_buyer?.toLocaleString(),
      width: "5%",
    },
    {
      title: "Regular",
      render: (record) => record?.selling_rate_regular,
      width: "5%",
    },
    {
      title: "Action",
      width: "5%",
      render: (record) => {
        return (
          <React.Fragment>
            {centerIds.includes(userProfile?.employee_id) ? null : (
              <div className="d-flex">
                <Tooltip title="Update">
                  <Button
                    className="d-flex align-items-center me-1"
                    onClick={() => handleUpdateModal(record)}
                  >
                    <EditOutlined />
                  </Button>
                </Tooltip>
                <Tooltip title="Damage">
                  <Button
                    className="d-flex align-items-center"
                    onClick={() => handleDamageModal(record)}
                  >
                    <RestOutlined />
                  </Button>
                </Tooltip>
              </div>
            )}
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <>
      <StockUpdateModal
        visible={stockUpdateModal}
        handleModalClose={handleUpdateModalClose}
        data={selectedProduct}
        fetchStockList={fetchStockList}
      />
      <StockDamageModal
        visible={stockDamageModal}
        handleModalClose={handleDamageModalClose}
        data={selectedProduct}
        fetchStockList={fetchStockList}
      />
      <div className="farmerDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>STOCK DETAILS</h5>
        </div>
        <div className="farmerDashboardContainer shadow-sm rounded">
          <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
            <div className="shadow-sm p-3">
              <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
                <div>
                  {centerIds?.includes(userProfile?.employee_id) ? null : (
                    <Select
                      placeholder="Select Center"
                      className="me-3"
                      onChange={handleCenter}
                      style={{ width: "200px" }}
                    >
                      <Option value="">All Center</Option>
                      {centerList?.map((center) => (
                        <Option
                          value={center?.center?.employee_id}
                          key={center?.center?.employee_id}
                        >
                          {center?.center_name}
                        </Option>
                      ))}
                    </Select>
                  )}
                  <RangePicker
                    suffixIcon={"Expiry Search"}
                    onChange={handleSalesDateRage}
                    value={selectedDateRange}
                    style={{ width: "320px" }}
                  />
                </div>
                <Search
                  className="w-25"
                  placeholder="search here..."
                  allowClear
                  onSearch={handleSearch}
                  enterButton={
                    <Button
                      style={{
                        backgroundColor: "#46604A",
                        borderColor: "#46604A",
                        color: "white",
                      }}
                    >
                      Search
                    </Button>
                  }
                />
              </div>
              <Table
                className="border"
                columns={stockColumn}
                dataSource={stockList}
                loading={stockLoading}
                rowKey={(record, index) => index}
                pagination={{
                  current: currentPage,
                  pageSize: 10,
                  total: totalItems,
                  onChange: handlePageChange,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
